import { useRouter } from '@atlassian/jira-router';

// Assume that if the path ends with /embed we are in an embedded page (this is the convention for Embed views)

export const useIsEmbedded = (): boolean => {
	const [
		{
			location: { pathname },
		},
	] = useRouter();

	return pathname.endsWith('/embed');
};
